
import styled from "styled-components"
import Graphic from "../../assets/images/login_graphic.svg"
import Pig from "../../assets/images/login_pig.png"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Row, Col } from "reactstrap"
import { useEffect } from "react"
import { CustomInput, CustomButton } from "../../components"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom";
import { useState } from "react"
import axios from 'axios';

const StyledCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledRow = styled(Row)`
    padding: 50px;
    @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
        padding: 20px 0;
    }
`;
const StyledHeader = styled.h5`
  color: ${COLORS.text_green};
`;
const StyledSideGreen = styled.img`
  position: absolute;
  height: 70%;
  left: 0;
  bottom: 0;
  z-index: 0;

  @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
      display: none;
    }
`;
export function VerifyEmail(props) {
    const api = process.env.REACT_APP_API_URL;
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [messageShown, setMessageShown] = useState('We are proceeding with email verification. Please wait...')
    useEffect(() => {
        async function fetchData() {
            const response = await axios.post(`${api}/pt/verify_email`, { token: props.token })
            const data = response.data;
            if (data.status_code == -101) {
                setError(true)
                setMessageShown(data.message)

            } else {
                setSuccess(true)
            }
        }
        fetchData();

    }, [])
    return (
        <>
            <StyledRow className="m-0 h-100 d-flex justify-content-center">
                <StyledSideGreen src={Graphic} />

                <StyledCol lg={8}>
                    {success ? <div><StyledHeader>Email Verification</StyledHeader><div>Your email has been successfully verified. Press button below to login to the app.</div>
                        <Link to="/">
                            <CustomButton
                                style={{ width: 200, marginTop: 10 }}
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                            >
                                Log In
                            </CustomButton>
                        </Link>
                    </div>
                        :
                        <div>
                            <StyledHeader>Email Verification</StyledHeader>
                            <div>{messageShown}</div>
                            {error && <Link to="/resend_verification"><CustomButton
                                style={{ width: 200, marginTop: 10 }}
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                            >
                                Resend Email
                            </CustomButton> </Link>}
                        </div>
                    }

                </StyledCol>
            </StyledRow>
        </>
    );
}

